import React from 'react';
import { useSelector } from 'react-redux';

import { MaterialUICore, Grid, Typography } from '@iclinic/design-system';
import {
  phoneFormatter,
  cnpjFormatter,
  dateFormatter,
} from 'shared/utils/formatters';
import useStyles from './ReadOnlyCardProfile.styles';
import { getSellerConfigSelector } from 'features/onlinePayment/state/config/register/selectors';

const { Avatar } = MaterialUICore;

export default function ReadOnlyCardProfilePJ(): JSX.Element | null {
  const classes = useStyles();
  const { seller, physician } = useSelector(getSellerConfigSelector);

  return (
    <Grid direction="column" spacing={3} container>
      <Grid spacing={3} item container>
        <Grid item>
          <Avatar
            classes={{
              root: classes.avatar,
              fallback: classes.fallback,
            }}
            src={physician?.profile?.thumb}
          />
        </Grid>
        <Grid item xs={12} sm="auto">
          <Typography variant="body2" className={classes.hint}>
            Razão social
          </Typography>
          <Typography variant="body1" className={classes.businessName}>
            {seller?.business_name}
          </Typography>
        </Grid>
      </Grid>
      <Grid item>
        <Typography variant="body2" className={classes.hint}>
          Nome fantasia
        </Typography>
        <Typography variant="body1">{seller?.business_description}</Typography>
      </Grid>
      <Grid spacing={3} item container>
        <Grid item xs={12} sm={6}>
          <Typography variant="body2" className={classes.hint}>
            Email
          </Typography>
          <Typography variant="body1">{seller?.email}</Typography>
        </Grid>
        <Grid item xs={12} sm={6}>
          <Typography variant="body2" className={classes.hint}>
            Data de abertura da empresa
          </Typography>
          <Typography variant="body1">
            {dateFormatter(String(seller?.business_opening_date) || '')}
          </Typography>
        </Grid>
      </Grid>
      <Grid spacing={3} item container>
        <Grid item xs={12} sm={6}>
          <Typography variant="body2" className={classes.hint}>
            Telefone da clinica
          </Typography>
          <Typography variant="body1">
            {phoneFormatter(seller?.phone || '')}
          </Typography>
        </Grid>
        <Grid item xs={12} sm={6}>
          <Typography variant="body2" className={classes.hint}>
            CNPJ
          </Typography>
          <Typography variant="body1">
            {cnpjFormatter(seller?.business_cnpj || '')}
          </Typography>
        </Grid>
      </Grid>
    </Grid>
  );
}
